import h from 'hyperscript';

import { LayerAttachmentsApi } from 'cadenza/api-client/layer-attachments-api';
import { logger } from 'cadenza/utils/logging';
import { on } from 'cadenza/utils/event-util';

export function enableFeatureZoomDecorator (fragment, clickHandler) {
  fragment.querySelectorAll('.featureZoomDecorator').forEach(decorator => {
    // nextUntil without jQuery
    let nextSibling = decorator.nextElementSibling;
    while (!nextSibling.classList.contains('featureZoomDecorator-end')) {
      on(nextSibling, 'click', () => clickHandler(decorator));
      nextSibling = nextSibling.nextElementSibling;
    }
  });
}

export function renderAttachmentList (elementToAttachTo, featureId, layerId) {
  fetchFeatureAttachmentsForFeatureId(featureId, layerId)
    .then(function (data) {
      const container = document.querySelector(elementToAttachTo);

      if (data.length > 0) {
        container.style.display = 'block';
      }

      const elements = data.map(element => {
        return h('div.media', [
          h('div.media-left',
            h('a', {
              href: element.url,
              target: '_blank'
            }, createFileTypeThumbnail(element))),
          h('div.media-body', [
            h('h4.media-heading', element.name),
            h('p', element.mimeType)
          ])
        ]);
      });
      const innerElement = h('div.fia-inner-container', elements);
      container.append(innerElement);
    })
    .catch((error) => {
      logger.error('Failed to load feature attachments.', error);
    });
}

export function renderAttachmentGrid (elementToAttachTo, featureId, layerId) {
  fetchFeatureAttachmentsForFeatureId(featureId, layerId)
    .then((data) => {
      const container = document.querySelector(elementToAttachTo);

      if (data.length > 0) {
        container.style.display = 'block';
      }

      const elements = data.map(element => {
        return h('a.fia-item', {
          href: element.url,
          target: '_blank'
        }, [
          createFileTypeThumbnail(element),
          h('div.fia-item-name', element.name)
        ]);
      });
      const innerElement = h('div.fia-inner-container', elements);
      container.append(innerElement);
    })
    .catch((error) => {
      logger.error('Failed to load feature attachments.', error);
    });
}

function fetchFeatureAttachmentsForFeatureId (featureId, layerId) {
  return new LayerAttachmentsApi(layerId).getAttachments(featureId);
}

function createFileTypeThumbnail (mediaObject) {
  let fileType = FILE_TYPES[mediaObject.mimeType];
  if (fileType === undefined) {
    fileType = 'default';
  }

  return FILE_TYPE_MAPPINGS[fileType](mediaObject);
}

const FILE_TYPES = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
  'application/pdf': 'pdf',
  'image/png': 'image'
};

const FILE_TYPE_MAPPINGS = {
  default: () => buildFileTypeIcon('fia-file-type-default'),
  pdf: () => buildFileTypeIcon('fia-file-type-pdf'),
  word: () => buildFileTypeIcon('fia-file-type-word'),
  excel: () => buildFileTypeIcon('fia-file-type-excel'),
  image: (mediaObject) => h('img.fia-item-image', { src: mediaObject.thumbnailUrl })
};

function buildFileTypeIcon (typeClass) {
  return h(`div.fia-file-type.${typeClass}`);
}
